<script lang="ts" setup>import { ref as _ref } from 'vue';

import YelpRating from '@consumer/modules/shared/YelpRating.vue'
import type { PlaceInfo } from '@consumer/types/serializers'
import defaultMerchantImageSrc from '@consumer/assets/icons/v6/merchant.svg'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import newGlobeIcon from '@consumer/assets/icons/new/globe.svg?svgicon'

withDefaults(defineProps<{
  place: PlaceInfo
  selected?: boolean
}>(), {  })

const merchantImageSrc = _ref(__props.place.imageUrl)
const merchantLocation = computed(() => [__props.place.city, __props.place.state].join(', '))
</script>

<template>
  <div
    class="
      bg-white border-1 border-solid border-grey-400 rounded-v2sm
      lg:hover:border-primary-base lg:hover:bg-primary-pale
      p-4 lg:p-3
      flex items-center justify-between gap-4 lg:gap-3 clickable
      relative
    "
    :class="{
      '!border-primary-base !bg-primary-pale': selected
    }"
    name="nc_local_place"
    :alt="place.name"
    :rel="place.noFollow ? 'nofollow' : undefined"
  >
    <div
      v-if="selected"
      class="absolute top-2 right-2 bg-primary-base text-white h-5 w-5
        rounded-v2xs flex items-center justify-center"
    >
      <GIcon :icon="faCheck" size="sm"/>
    </div>

    <img
      class="flex-0 rounded-v2xs"
      height="80"
      width="80"
      :src="merchantImageSrc || defaultMerchantImageSrc"
      @error="merchantImageSrc = defaultMerchantImageSrc"
    >

    <div class="flex-1 flex flex-col justify-center gap-1.5 text-sm">
      <div
        class="font-semibold overflow-ellipsis text-navy"
        data-testid="place-name"
      >{{ place.name }}</div>
      <div
        v-if="place.rating|| place.reviewsCount"
        class="flex items-center gap-2 text-grey-700 text-sm font-semibold"
      >
        <YelpRating v-if="place.rating" :rating="place.rating"/>
        <span v-if="place.reviewsCount" class="lg:hidden">{{ place.reviewsCount }} Reviews</span>
        <span v-if="place.reviewsCount" class="hidden lg:block">({{ place.reviewsCount }})</span>
      </div>
      <div class="flex items-center gap-1 text-grey-700 text-sm font-semibold">
        <template v-if="place.placeType === 'list' || place.placeType === 'brand'">
          <GIcon :svg="newGlobeIcon" size="12px" color="grey-700"/>
          <template v-if="place.numberOfLocations && place.numberOfLocations > 10">
            {{ place.numberOfLocations }} Locations
          </template>
          <template v-else>Nationwide</template>
        </template>
        <template v-else>
          {{ merchantLocation }}
          &nbsp;
          {{ place.price }}
        </template>
      </div>
    </div>
  </div>
</template>
